import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../image/logo.png";

function Header({ openContactModal, openMeetingModal }) {
  const [menuOpen, setMenuOpen] = useState(false);
   const message = "Hello, I want to know about home construction.";


const [rotate, setRotate] = useState(false);
const lastScrollY = useRef(0);

useEffect(() => {
  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY.current) {
      // Scroll Down
      setRotate(true);
    } else {
      // Scroll Up
      setRotate(false);
    }

    lastScrollY.current = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
    <header className="site-header">
      
      <div className="header-inner">
        <div className="header-content">

          {/* LOGO */}
          <div className="logo-wrap">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {/* <img
                src="image/logo.png"
                alt="Dwellora Homes"
                className="logo-img"
              /> */}

{/* <img
  src={logo}
  alt="Dwellora Homes"
  className="logo-img"
/> */}

{/* <img
  src={logo}
  alt="Dwellora Homes"
  className={`logo-img ${rotate ? "rotate" : ""}`}
  onClick={() => setRotate(false)}
/> */}

<img
  src={logo}
  alt="Dwellora Homes"
  className={`logo-img ${rotate ? "rotate" : ""}`}
/>

              </Link>

              <div className="logo-text">
                 <Link to="/" onClick={() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
                <div className="logo-title">Dwellora Homes</div></Link>
              </div>
            
          </div>

          {/* DESKTOP NAV */}
          <nav className="header-nav">

{/* <a 
  href="https://contact.dwellorahomes.com/" 
  className="nav-link-custom"
  target="_blank" 
  rel="noopener noreferrer"
>
  Calculate my Cost
</a> */}

            <Link to="/estimate" className="nav-link-custom">
             Calculate my Cost
            </Link>

            {/* <a href="#services" className="nav-link-custom">
  What we do
</a> */}

<Link to="/#services" className="nav-link-custom">
  What we do
</Link>

            {/* <Link to="/calculate" className="nav-link-custom">
              Calculate my cost
            </Link>

            <button onClick={openContactModal} className="btn-meeting">
              Book a Meeting
            </button> */}


  <Link onClick={openMeetingModal} className="nav-link-custom">
             Book a Meeting
            </Link>

            <Link to="/projects" className="nav-link-custom">
  Our Project
</Link>

            <Link to="/calculate" className="btn-meeting">
  Get a Free Quote
</Link>

          </nav>

          {/* MOBILE TOGGLE */}
          <div
            className="mobile-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`bi ${menuOpen ? "bi-x" : "bi-list"}`}></i>
          </div>
        </div>
      </div>

      {/* OVERLAY */}
      <div
        className={`mobile-overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* MOBILE SIDEBAR */}

{/* MOBILE FULLSCREEN MENU */}
<div className={`mobile-fullscreen ${menuOpen ? "active" : ""}`}>

  {/* TOP BAR (Logo + Close Same Line) */}
  <div className="mobile-topbar">

    <Link
  to="/"
  className="mobile-brand"
  onClick={() => {
    setMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }}
>
  <img src={logo} alt="logo" />
  <span>Dwellora Homes</span>
</Link>

    <div className="mobile-close" onClick={() => setMenuOpen(false)}>
      <i className="bi bi-x-lg"></i>
    </div>

  </div>

  {/* CENTER CONTENT */}
  <div className="mobile-full-content">

  {/* <Link
    to="/"
    onClick={() => setMenuOpen(false)}
    className="full-link"
  >
    <i className="bi bi-house-door"></i>
    What we do
  </Link> */}

            {/* <a href="#services"   onClick={() => setMenuOpen(false)}
    className="full-link" >  <i className="bi bi-house-door"></i>
  What we do
</a> */}

<Link
  to="/#services"
  onClick={() => setMenuOpen(false)}
  className="full-link"
>
  <i className="bi bi-house-door"></i>
  What we do
</Link>


  {/* <a
    href="https://contact.dwellorahomes.com/"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => setMenuOpen(false)}
    className="full-link"
  >
    <i className="bi bi-calculator"></i>
    Calculate my Cost
  </a> */}

<Link
  to="/estimate"
  onClick={() => setMenuOpen(false)}
  className="full-link"
>
  <i className="bi bi-calculator"></i>
  Calculate my Cost
</Link>

 {/* <Link
  onClick={() => {
    openContactModal();
    setMenuOpen(false);
  }}
  className="full-link"
>
  <i className="bi bi-calendar-check"></i>
  Book a Meeting
</Link> */}


<Link
  onClick={() => {
    setMenuOpen(false);
    openMeetingModal();   
  }}
  className="full-link"
>
  <i className="bi bi-calendar-check"></i>
  Book a Meeting
</Link>

<Link
  to="/projects"
  onClick={() => setMenuOpen(false)}
  className="full-link"
>
  <i className="bi bi-folder"></i>
 Our Project
</Link>


  {/* <button
    onClick={() => {
      openContactModal();
      setMenuOpen(false);
    }}
    className="full-btn"
  >
    Book a Meeting
  </button> */}

  <Link
  to="/calculate"
  onClick={() => setMenuOpen(false)}
  className="full-btn"
>
  Get a Free Quote
</Link>

<div className="mobile-follow-wrapper">
  <span>Connect With Dwellora</span>
</div>

<div className="mobile-socials">

  {/* Instagram */}
  <a 
    href="https://www.instagram.com/dwellora.homes?igsh=MTJmdXdkcDJ2amFvNw==" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <i className="bi bi-instagram"></i>
  </a>

  {/* WhatsApp */}
 
<a 
  href={`https://wa.me/919158914222?text=${encodeURIComponent(message)}`}
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="bi bi-whatsapp"></i>
</a>

</div>

</div>

</div>
    </header>
  );
}

export default Header;